import Model from '@/models/Model.js';

export default class TimePeriodLocation extends Model {
    static entity = 'time_period_location';

    static modelName = 'TimePeriodLocation';

    static primaryKey = ['time_period_id', 'location_id'];

    static fields() {
        return {
            location_id: this.attr(null),
            time_period_id: this.attr(null),

            ...super.fields(),

            location: this.belongsTo('locations', 'location_id'),
            time_period: this.belongsTo('time_periods', 'time_period_id'),
        };
    }
}
